const Form051TC = {
    stepName: {
        importantNotes: "重要提示",
        applicantInformation: "申請人資料",
        confirmation: "確認",
    },
    title: {
        applicantInformation: "申請人資料",
        applicantNotePoints: "申請人須知",
        completedApplicant1: `此欄由申請人填寫`,
        completedApplicant2: `如選擇以平郵寄回報告複本，請在下面用正楷寫上收件人姓名及本地郵寄地址。`,
        // completedApplicant3: `請在下面用正楷寫上收件人姓名及本地郵寄地址。`,
        completedByEDB: "此欄由教育局填寫",
    },
    note: {
        note1: `(1)	申請人如欲索取聽力報告的複本，請填妥本表格並上載所需的證明文件。`,
        note2: `(2)	申請人須年滿十八歲。`,
        note3: `(3)	如申請人拒絕提供所需的資料或所提供的資料不正確，教育局將無法提供所需服務。`,
        note4: `(4)	個人資料使用聲明：申請人在此表格上所提供的資料，將用作核實與此要求有關的資料及其他與之直接有關的用途。`,
        note4ii:
            "(4) 個人資料收集聲明：教育局會使用本表格所載的個人資料，作核實你要求索取聽力報告的複本及其他與之直接有關的用途。",

        note5: `(5)	如有疑問，請向教育局教育聽力服務組查詢（電話：3698 3909）。`,
        note6: `報告複本備妥後，請用以下方法交予本人（請選擇其中`,
        note7: "致申請人：",
        note8: "現附上聽力報告複本共",
        note9: "頁，敬請查收。",
        note10: "如有疑問，請聯絡教育局教育聽力服務組（電話：3698 3909）。",
        note11: "一項",
        note12: ")：",
    },
    label: {
        identityOption: {
            aboveStudent: {
                aboveStudent1: "本人是",
                aboveStudent2: "本人的身份證明文件影印本",
                aboveStudent3: "，以向教育局索取本人的聽力報告複本一份。",
                aboveStudent4: "上述學生",
                aboveStudent5: "，現夾附",
            },
            aboveStudentParent: `本人是上述學生的`,
            aboveStudentGuardian: {
                text1: `本人是上述學生的`,
                text2: `監護人`,
                text3: `(與學生的關係：`,
            },
        },
        relationshipMsg: "關係",
        aboveStudentParentOption: {
            father: "父親",
            mother: "母親",
        },
        aboveStudentParentOptions: {
            aboveStudentFather: `父親`,
            aboveStudentMother: `母親`,
        },
        aboveStudentGuardianOption: {
            aboveStudentGuardianFather: `上述學生的`,
            aboveStudentGuardianMother: `其他證明文件的影印本`,
        },
        aboveStudentGuardianOptions: {
            aboveStudentGuardianFather: `父親`,
            aboveStudentGuardianMother: `母親`,
        },
        aboveStudentiDentityCardOptions: {
            informMe: `通知本人親身領取`,
            mailMe: `用平郵寄給本人(請填上收件人姓名及本地郵寄地址)`,
        },
        identityTypeOption: {
            HKIDCard: "香港身份證",
            passport: "護照",
            permit: "往來港澳通行證",
        },
        aboveStudentParentEnd: `，`,
        aboveStudentParentEnd1: {
            text1: "現夾附(1)",
            text2: "本人的身份證明文件影印本",
            text3: "及(2)",
            text4: "上述學生的出生證明文件或其他證明文件影印本",
            text5: "，以示本人為上述學生的家長，以向教育局索取上述學生的聽力報告複本一份。",
        },
        aboveStudentGuardianEnd: {
            text1: "現夾附(1)",
            text2: "本人的身份證明文件影印本",
            text3: "、(2)",
            text4: "上述學生的出生證明文件或其他證明文件影印本",
            text5: "及(3)",
            text6: "以下的證明文件",
            text7: "，以示本人為上述學生的監護人，以向教育局索取上述學生的聽力報告複本一份",
        },
        guardianParentChoiceEnd: "的身份證明文件影印本",
        studentEnName: "學生姓名（英文）",
        studentCnName: "學生姓名（中文）",
        studentNameMsg: "學生姓名",
        birthDate: "出生日期",
        identityNo: "身份證明文件號碼",
        identityNoMsg: "身份證明文件號碼",
        issuedDate: `所要求的報告的大概發出日期或年份：(如沒有註明，則設定為教育局記錄上最近期的聽力報告。)`,
        applicantName: "學生姓名",
        applicantSignature: "申請人簽署",
        identityDocumentNo: "身份證明文件號碼",
        identityDocumentType: "身份證明文件類別",
        identityDocumentMsg: "身份證明文件號碼",
        contactTelephone: "本地日間聯絡電話",
        telephoneNumber: "電話號碼",
        otherDocument: "證明文件",
        date: "日期",
        name: "收件人",
        address: "本地郵寄地址",
        page: "頁數",
    },
    errorMsg: {
        englishNameRule:
            "請輸入正確的規則（字符類型（僅字母/字母數字/僅中文）和特殊字符為逗號(,)、空格( )、加號(+)、哈希(#)、括號(()) 和連字符 (-).)",
        rule: "請輸入正確的規則（字符類型（僅限字母/字母數字/僅限中文））",
        telMsg: "電話號碼必須為最多8位數",
        nameMsg: "請輸入一個有效的收件人姓名",
        attachedFile: "你的身份證明文件影印本",
        parentAttachedFile:
            "你的身份證明文件影印本以及上述學生的出生證明文件或其他證明文件影印本",
        studentRelationship: "與學生的關係",
        otherDocumentTemp: "其他證明文件的資料",
        otherDocument: "其他證明文件的影印本",
        relationshipRequired: "請選擇關係",
        guardianChoiceRequired: "請選擇文件類型",
        identityCardChoiceRequired: "請選擇方法",
        identityChoiceRequired: "請選擇身份證明文件類型",
        name: "收件人姓名",
        address: "本地郵寄地址",
        identityNo: "身份證明文件號碼",
    },
};
export default Form051TC;
